var env = require("../utils/env");
var apiDomain = env.domain.api;
var Auth = require("./auth");
var request = require('superagent');

var exports = module.exports = {};

exports.retrieveAttempts = function(options, callback) {
  var DEFAULT_LIMIT = 20;
  callback = callback || function(){};
  options = options || {};
  var conditions = options.conditions || {};
  conditions.status = conditions.status || 'to_be_marked';
  request
  .get(apiDomain + "/v1/attempts")
  .query({
    sort: options.sort || '-dateScored',
    limit: options.limit || DEFAULT_LIMIT,
    skip: options.skip || 0,
    conditions: JSON.stringify(conditions)
  })
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body);
  }, function(err) {
    return callback(err);
  })
}

exports.retrieveSingleAttempt = function(options, callback) {
  callback = callback || function(){};
  if (!options.attemptId) return callback('INVALID ATTEMPT');
  request
  .get(apiDomain + "/v1/attempts/" + options.attemptId)
  .query(options.query)
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body)
  }, function(err) {
    return callback(err);
  })
}

exports.submitAnswerMessage = function(options, callback) {
  callback = callback || function(){};
  options = options || {};
  options.type = 'ANSWER_MESSAGE';
  request
  .post(apiDomain + "/v1/message")
  .send(options)
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body);
  }, function(err) {
    return callback(err)
  })
}

exports.updateAttempt = function(attempt, callback) {
  callback = callback || function(){};
  if (!attempt || !attempt._id) return callback('INVALID ATTEMPT');
  request
  .put(apiDomain + "/v1/attempts/" + attempt._id)
  .send(attempt)
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body);
  }, function(err) {
    return callback(err);
  })
}

exports.updateAttemptAnswer = function(attempt, answer, callback) {
  callback = callback || function(){};
  if (!attempt || !attempt._id) return callback('INVALID ATTEMPT');
  if (!answer || !answer._id) return callback('INVALID ANSWER');
  request
  .post(apiDomain + "/v1/attempts/" + attempt._id + "/answers/" + answer._id)
  .send(answer)
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body);
  }, function(err) {
    return callback(err);
  })
}

exports.countAttempt = function(conditions, callback) {
  callback = callback || function(){};
  request
  .get(apiDomain + "/v1/attempts/count")
  .query({
    conditions: JSON.stringify(conditions)
  })
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body)
  }, function(err) {
    return callback(err);
  })
}



/** WEBPACK FOOTER **
 ** ./src/resources/attempt.js
 **/